import React from "react";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import CollectionPage from "./CollectionPage/CollectionPage";
import LandingPage from "./LandingPage/LandingPage";
import ConfiguratorPage from "./ConfiguratorPage/ConfiguratorPage";
import SummaryPage from "./SummaryPage/SummaryPage";
import CollectionPageNecklace from "./CollectionPage/CollectionPageNecklace";
import {
  initRings,
  fetchCollectionPageFields,
  fetchConfiguratorPageFields,
  fetchLandingPageFields,
  fetchCollections,
  fetchSummaryPageFields,
  fetchHolderRings,
  fetchMainRings,
  selectActiveMainRing,
  selectActiveHolderRings,
  fetchCollectionPageNecklaceFields,
  initNecklacesAndMemories,
  fetchConfiguratorPageNecklaceFields,
} from "../redux/actions";
import ConfiguratorPageNecklace from "./ConfiguratorPage/ConfiguratorPageNecklace";
import SummaryPageNecklace from "./SummaryPage/SummaryPageNecklace";
const DISABLE_NECKLACE = process.env.REACT_APP_DISABLE_NECKLACE;

class Home extends React.Component {
  componentDidMount() {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    this.props.initRings(queryParams);
    this.props.initNecklacesAndMemories(queryParams);
    this.props.fetchCollectionPageFields();
    this.props.fetchCollectionPageNecklaceFields();
    this.props.fetchConfiguratorPageFields();
    this.props.fetchConfiguratorPageNecklaceFields();
    this.props.fetchCollections();
    this.props.fetchLandingPageFields();
    this.props.fetchSummaryPageFields();
  }

  render() {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams) {
      switch (queryParams.view) {
        case "landing-page":
          return <LandingPage />;
        case "collection":
          return <CollectionPage />;
        case "digital-showroom":
          return <ConfiguratorPage />;
        case "digital-showroom-necklace":
          if (DISABLE_NECKLACE) {
            return <LandingPage />;
          } else {
            return <ConfiguratorPageNecklace />;
          }
        case "summary":
          return <SummaryPage />;
        case "summary-necklace":
          if (DISABLE_NECKLACE) {
            return <LandingPage />;
          } else {
            return <SummaryPageNecklace />;
          }
        case "collection-necklace":
          if (DISABLE_NECKLACE) {
            return <LandingPage />;
          } else {
            return <CollectionPageNecklace />;
          }
        default:
          return <LandingPage />;
      }
    } else {
      return <LandingPage />;
    }
  }
}

const mapStateToProps = ({ ring }) => {
  const { activeMainRing, mainRings, loadingMainRings } = ring;

  return {
    loadingMainRings,
    activeMainRing,
    mainRings,
  };
};

export default connect(mapStateToProps, {
  initRings,
  fetchCollectionPageFields,
  fetchCollectionPageNecklaceFields,
  fetchConfiguratorPageFields,
  fetchLandingPageFields,
  fetchCollections,
  fetchSummaryPageFields,
  fetchMainRings,
  fetchHolderRings,
  selectActiveMainRing,
  selectActiveHolderRings,
  initNecklacesAndMemories,
  fetchConfiguratorPageNecklaceFields,
})(withRouter(Home));
